import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    return await originalFetch(...args);
  } catch (err) {
    console.warn('Fetch failed:', args[0]);
    return new Response(
      JSON.stringify({ status: 'offline' }),
      {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
